

import { useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { updateYukData } from "../../../../../features/updateLoad/updateLoadSlice"
import { useEffect } from "react"

const Container = styled.div`
    width: 500px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;

    textarea{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        color: var(--color-dark);
        background-color: ${({theme}) => theme.mainBgColor};
        resize: vertical;
        min-height: 40px;
        max-height: 140px;

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    textarea:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        top: 14px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }
`

const YukAdrDescriptionInput = ({data, isRequired, name, labelText="Sürücünün Yükle İlgili Neyi Bilmesi Gerekiyor"}) => {

    const [text, setText] = useState(data.yukAdrDescription)
    const dispatch = useDispatch()

    useEffect(() => {
        setText(data.yukAdrDescription)
    },[data.yukAdrDescription])

    const handleChange = (e) => {
        setText(e.target.value)

        dispatch(updateYukData({yukAdrDescription: e.target.value}))
    }

    
  return (
    <Container value={text} radius={"5px"}>
        <textarea  id={"text"} onChange={handleChange} value={text} name={name}/> 
        <label htmlFor={"text"}>{labelText}</label>
    </Container>
  )
}

export default YukAdrDescriptionInput